export default __webpack_public_path__ + "static/media/Landing diet – 2.cbe3d9fe.png";